if (!window.__ndPdpLoaded) {
window.__ndPdpLoaded = true;
/* NODE Triton — comportos da PDP: personalização, patches junto no ATC, cupom, ATC flutuante */

/* Personalização: toggle + maiúsculas + só número */
class NdPersonalization extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('.nd-perso__body');
    this.on = this.querySelector('[data-nd-perso-on]');
    this.off = this.querySelector('[data-nd-perso-off]');
    this.inputs = [...this.querySelectorAll('input')];
    this.on.addEventListener('click', () => this.toggle(true));
    this.off.addEventListener('click', () => this.toggle(false));
    this.querySelectorAll('[data-nd-upper]').forEach((i) =>
      i.addEventListener('input', () => { i.value = i.value.toUpperCase(); })
    );
    this.querySelectorAll('[inputmode="numeric"]').forEach((i) =>
      i.addEventListener('input', () => { i.value = i.value.replace(/\D/g, ''); })
    );
  }

  syncVariantOption(active) {
    const section = this.closest('.shopify-section') || document;
    const radios = [...section.querySelectorAll('.nd-hidden-option input[type=radio]')];
    if (!radios.length) return;
    const want = active
      ? radios.find((r) => /customi|personaliz/i.test(r.value))
      : radios.find((r) => /^no|sem/i.test(r.value)) || radios[0];
    if (want && !want.checked) { want.checked = true; want.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  toggle(active) {
    this.syncVariantOption(active);
    this.on.classList.toggle('is-active', active);
    this.off.classList.toggle('is-active', !active);
    this.body.hidden = !active;
    this.inputs.forEach((i) => { i.disabled = !active; if (!active) i.value = ''; });
  }
}
if (!customElements.get('nd-personalization')) customElements.define('nd-personalization', NdPersonalization);

/* Patches: intercepta o submit do form do produto e adiciona os patches marcados antes */
class NdPatches extends HTMLElement {
  connectedCallback() {
    const section = this.closest('section, .shopify-section') || document;
    // a seção tem 2 forms /cart/add (o de parcelamento vem primeiro e não tem botão) — escuta o que compra
    this.form = [...section.querySelectorAll('form[action*="/cart/add"]')].find((f) => f.querySelector('[name="add"], button[type="submit"]'));
    if (!this.form) return;
    this.bypass = false;
    // badge com a contagem de patches marcados no cabeçalho recolhível
    const badge = this.querySelector('[data-nd-patch-count]');
    if (badge) {
      this.addEventListener('change', () => {
        const n = this.querySelectorAll('.nd-patch__input:checked').length;
        badge.textContent = n;
        badge.hidden = n === 0;
      });
    }
    this.form.addEventListener(
      'submit',
      async (e) => {
        if (this.bypass) { this.bypass = false; return; }
        const ids = [...this.querySelectorAll('.nd-patch__input:checked')].map((i) => Number(i.dataset.ndPatchVariant));
        if (!ids.length) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        try {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) }),
          });
        } catch (err) {
          console.error('[nd-patches] falha ao adicionar patch:', err);
        }
        this.bypass = true;
        this.form.requestSubmit();
      },
      true
    );
  }
}
if (!customElements.get('nd-patches')) customElements.define('nd-patches', NdPatches);

/* Cupom copiável */
class NdCoupon extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-nd-copy]');
    if (!btn) return;
    const original = btn.textContent;
    btn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(this.dataset.code);
        btn.textContent = btn.dataset.copiedLabel || original;
        setTimeout(() => { btn.textContent = original; }, 2000);
      } catch { /* clipboard bloqueado: mantém o código visível no texto */ }
    });
  }
}
if (!customElements.get('nd-coupon')) customElements.define('nd-coupon', NdCoupon);

/* Coluna de thumbnails própria (o slider nativo do Dawn fica escondido) */
if (window.matchMedia('(min-width: 990px)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('media-gallery');
    const nativeThumbs = gallery && gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!gallery || !nativeThumbs) return;
    const nativeBtns = [...nativeThumbs.querySelectorAll('.thumbnail')];
    if (nativeBtns.length < 2) { nativeThumbs.classList.add('nd-thumbs-hidden'); return; }
    const col = document.createElement('div');
    col.className = 'nd-thumbcol';
    const list = document.createElement('div');
    list.className = 'nd-thumbcol__list';
    nativeBtns.forEach((btn, i) => {
      const img = btn.querySelector('img');
      if (!img) return;
      const t = document.createElement('button');
      t.type = 'button';
      t.className = 'nd-thumbcol__item' + (i === 0 ? ' is-active' : '');
      t.innerHTML = '<img src="' + img.src + '" alt="" loading="lazy">';
      t.addEventListener('click', () => {
        btn.click();
        [...list.children].forEach((c) => c.classList.remove('is-active'));
        t.classList.add('is-active');
      });
      list.appendChild(t);
    });
    const arrow = (dir, cls) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'nd-thumbcol__arrow ' + cls;
      b.setAttribute('aria-label', dir > 0 ? 'Next photos' : 'Previous photos');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
      b.addEventListener('click', () => list.scrollBy({ top: dir * 200, behavior: 'smooth' }));
      return b;
    };
    col.appendChild(arrow(-1, 'nd-thumbcol__arrow--up'));
    col.appendChild(list);
    col.appendChild(arrow(1, 'nd-thumbcol__arrow--down'));
    nativeThumbs.classList.add('nd-thumbs-hidden');
    gallery.insertBefore(col, gallery.firstChild);
  });
}

/* Cometa do "How your order works": contorna cada bolinha e desce a linha, check no fim */
document.addEventListener('DOMContentLoaded', async () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.fonts && document.fonts.ready) { try { await document.fonts.ready; } catch (e) {} }
  const build = (body) => {
    body.querySelectorAll('.nd-how__comet').forEach((old) => old.remove());
    const icos = [...body.querySelectorAll('.nd-how__ico')];
    if (icos.length < 2) return;
    if (getComputedStyle(body).position === 'static') body.style.position = 'relative';
    const bb = body.getBoundingClientRect();
    const pts = icos.map((el) => {
      const r = el.getBoundingClientRect();
      return { cx: r.left - bb.left + r.width / 2, cy: r.top - bb.top + r.height / 2, r: r.width / 2 + 4 };
    });
    let d = '';
    pts.forEach((p, i) => {
      const top = (p.cy - p.r).toFixed(1);
      const bot = (p.cy + p.r).toFixed(1);
      const x = p.cx.toFixed(1);
      if (i === 0) d += 'M ' + x + ' ' + top + ' ';
      else d += 'L ' + x + ' ' + top + ' ';
      d += 'A ' + p.r + ' ' + p.r + ' 0 0 1 ' + x + ' ' + bot + ' ';
      d += 'A ' + p.r + ' ' + p.r + ' 0 0 1 ' + x + ' ' + top + ' ';
      d += 'A ' + p.r + ' ' + p.r + ' 0 0 1 ' + x + ' ' + bot + ' ';
    });
    const svgNS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('class', 'nd-how__comet');
    svg.setAttribute('width', bb.width);
    svg.setAttribute('height', bb.height);
    svg.setAttribute('viewBox', '0 0 ' + bb.width + ' ' + bb.height);
    ['nd-how__comet-glow', 'nd-how__comet-core'].forEach((cls) => {
      const p = document.createElementNS(svgNS, 'path');
      p.setAttribute('d', d.trim());
      p.setAttribute('class', cls);
      p.setAttribute('pathLength', '1000');
      p.setAttribute('fill', 'none');
      svg.appendChild(p);
    });
    body.appendChild(svg);
    const done = body.querySelector('.nd-how__step:last-child .nd-how__done');
    if (done) done.classList.add('nd-how__done--run');
  };
  const bodies = [...document.querySelectorAll('.nd-how__body')];
  bodies.forEach(build);
  let rz;
  window.addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => bodies.forEach(build), 300); });
});

/* ATC flutuante: aparece quando o botão real sai da tela */
class NdStickyAtc extends HTMLElement {
  // O Dawn re-renderiza o form de compra depois do load (troca de variante), então nó de botão
  // não é âncora estável: a cada verificação re-buscamos o botão atual e lemos a posição dele.
  connectedCallback() {
    this.section = this.closest('.shopify-section') || document;
    this.querySelector('[data-nd-sticky-atc]').addEventListener('click', () => {
      const form = this.buyForm();
      if (form) form.requestSubmit();
    });
    let agendado = false;
    this.onScroll = () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(() => {
        agendado = false;
        this.sync();
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.sync();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  buyForm() {
    // a seção tem 2 forms /cart/add (o de parcelamento não tem botão) — pega o que compra de verdade
    return [...this.section.querySelectorAll('form[action*="/cart/add"]')].find((f) =>
      f.querySelector('[name="add"], button[type="submit"]')
    );
  }

  sync() {
    const form = this.buyForm();
    const btn = form && form.querySelector('[name="add"], button[type="submit"]');
    if (!btn) return;
    this.classList.toggle('is-visible', btn.getBoundingClientRect().bottom < 0);
  }
}
if (!customElements.get('nd-sticky-atc')) customElements.define('nd-sticky-atc', NdStickyAtc);

}

/* NODE: prazo de entrega vivo — datas com base no dia em que a página está aberta */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-nd-eta]').forEach(function (el) {
    var fmt = function (dias) {
      var d = new Date();
      d.setDate(d.getDate() + dias);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };
    var de = el.querySelector('[data-nd-eta-from]');
    var ate = el.querySelector('[data-nd-eta-to]');
    if (de) de.textContent = fmt(parseInt(el.dataset.min, 10) || 8);
    if (ate) ate.textContent = fmt(parseInt(el.dataset.max, 10) || 15);
  });
});
